<template>
  <nav class="navbar navbar-default">
    <div class="container-fluid">
      <div class="navbar-minimize">
        <button class="btn btn-fill btn-icon" @click="minimizeSidebar">
          <i :class="$sidebar.isMinimized ? 'ti-menu-alt' : 'ti-more-alt'"></i>
        </button>
      </div>
      <div class="navbar-header">
        <button type="button" class="navbar-toggle" :class="{toggled: $sidebar.showSidebar}" @click="toggleSidebar">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar bar1"></span>
          <span class="icon-bar bar2"></span>
          <span class="icon-bar bar3"></span>
        </button>
        <a class="navbar-brand">{{$route.name}}</a>
      </div>
      <div class="collapse navbar-collapse">
        <!--
          <form class="navbar-form navbar-left navbar-search-form" role="search">
            <div class="input-group">
              <input type="text" value="" class="form-control" placeholder="Search...">
              <span class="input-group-addon"><i class="fa fa-search"></i></span>
            </div>
          </form>
        -->
        <ul class="nav navbar-nav navbar-right">
          <drop-down tag="li" :title="username" :subtitle="(!$store.state.isApplicant || $store.state.applicantPays) && $store.getters.allowedTypes.length > 0 ? credit : null" :alert="this.$store.state.isImpersonating" style="white-space: pre-line; text-align: right; margin-right: 20px">
            <li><router-link to="/account" class="btn-magnify"><i class="fa fa-user"></i>&nbsp;My account</router-link ></li>
            <li v-if="(!$store.state.isApplicant || $store.state.applicantPays) && $store.state.currentCredit != null && $store.getters.allowedTypes.length > 0 && !$store.state.isIndividual">
              <router-link v-if="$store.getters.usesTokens" to="/credit/order" class="btn-magnify"><i class="fa fa-plus-circle"></i>&nbsp;Order more credits</router-link >
              <router-link v-else to="/credit/buy" class="btn-magnify"><i class="fa fa-credit-card"></i>&nbsp;Buy more credit</router-link >
            </li>
            <!-- COUNTRY ACCESS -->
            <li v-if="$store.state.isImpersonating">
              <a :href="countryAccessData.href" @click="updateCountryAccess">
                <i class="fa fa-globe"></i>&nbsp;Country Insights 
                <span :class="countryAccessData.class">{{countryAccessData.text}}</span>
              </a>
            </li>
            <!-- ANALYTICS -->
            <li v-if="$store.state.isImpersonating">
              <a :href="analyticsAccessData.href" @click="updateAnalyticsAccess">
                <i class="ti-bar-chart-alt"></i>&nbsp;Analytics 
                <span :class="analyticsAccessData.class">{{analyticsAccessData.text}}</span>
              </a>
            </li>
            <!-- REPORTS ACCESS -->
            <li v-if="$store.state.isImpersonating">
              <a :href="reportsAccessData.href" @click="updateReportsAccess">
                <i class="ti-bar-chart-alt"></i>&nbsp;Reports 
                <span :class="reportsAccessData.class">{{reportsAccessData.text}}</span>
              </a>
            </li>
            <li><a href="#" @click.prevent="logout" class="btn-magnify"><i class="fa fa-sign-out"></i>&nbsp;Logout</a ></li>
          </drop-down>
          <!--
          <li class="open">
            <router-link to="/admin/stats" class="dropdown-toggle btn-magnify" data-toggle="dropdown">
              <i class="ti-panel"></i>
              <p>Stats</p>
            </router-link>
          </li>
          <li>
            <router-link to="/admin/overview" class="btn-rotate">
              <i class="ti-settings"></i>
            </router-link>
          </li>
          -->
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
  import ModalOptions from 'src/components/ModalPlugin/ModalOptions'
  import accounting from 'accounting'

  export default {
    data () {
      return {
        activeNotifications: false,
        countryAccessData: {},
        analyticsAccessData: {},
        reportsAccessData: {},
      }
    },
    computed: {
      username () {
        let username = this.$store.state.username
        if(this.$store.state.isImpersonating) {
          username = "QC Admin on behalf of " + username
        }
        return username
      },
      credit () {
        if(this.$store.getters.usesTokens) {
          return this.$store.state.currentCredit != null ? 'Current balance: ' + this.$store.state.currentCredit + ' credit(s)' : ''
        } else {
          return this.$store.state.currentCredit != null ? 'Current credit: ' + accounting.formatMoney(this.$store.state.currentCredit) : ''
        }
      }
    },
  created() {
    if (this.$store.state.currency == 'USD') {
      accounting.settings.currency.symbol = "$";
    } else if (this.$store.state.currency == 'EUR') {
      accounting.settings.currency.symbol = "€";
    } else if (this.$store.state.currency == 'AUD') {
      accounting.settings.currency.symbol = "$";
    } else {
      accounting.settings.currency.symbol = "£";
    }

      //this.minimizeSidebar()
    },
    mounted() {
      this.setInitAccess()
    },
    methods: {
        updateReportsAccess() {
          if(this.$store.state.hasReportsAccess) {
            this.reportsAccessData = {
              text: "OFF",
              class: "text-danger",
              href: "#/dashboard",
            }
          } else { 
            this.reportsAccessData = {
              text: "ON",
              class: "text-success",
              href: "#/analytics",
            }
        }
        this.$store.state.hasReportsAccess = !this.$store.state.hasReportsAccess
        if(this.$store.state.hasReportsAccess && !this.$store.state.hasAnalyticsAccess) {
          this.updateAnalyticsAccess()
        }
      },
        updateCountryAccess() {
          if(this.$store.state.hasCountryAccess) {
            this.countryAccessData = {
              text: "OFF",
              class: "text-danger",
              href: "#/dashboard",
            }
          } else { 
            this.countryAccessData = {
              text: "ON",
              class: "text-success",
              href: "#/countryInfo",
            }
        }
        this.$store.state.hasCountryAccess = !this.$store.state.hasCountryAccess
      },
      updateAnalyticsAccess() {
        if(this.$store.state.hasAnalyticsAccess) {
            this.analyticsAccessData = {
              text: "OFF",
              class: "text-danger",
              href: "#/dashboard",
            }
          } else { 
            this.analyticsAccessData = {
              text: "ON",
              class: "text-success",
              href: "#/analytics",
            }
        }
        this.$store.state.hasAnalyticsAccess = !this.$store.state.hasAnalyticsAccess
      },
      setInitAccess() {
        if(!this.$store.state.hasAnalyticsAccess) {
          this.analyticsAccessData = {
            text: "OFF",
            class: "text-danger",
            href: "#/dashboard",
          }
        } else { 
          this.analyticsAccessData = {
            text: "ON",
            class: "text-success",
            href: "#/analytics",
          }
        }
        if(!this.$store.state.hasCountryAccess) {
          this.countryAccessData = {
            text: "OFF",
            class: "text-danger",
            href: "#/dashboard",
          }
        } else { 
          this.countryAccessData = {
            text: "ON",
            class: "text-success",
            href: "#/countryInfo",
          }
        }
        if(!this.$store.state.hasReportsAccess) {
          this.reportsAccessData = {
            text: "OFF",
            class: "text-danger",
            href: "#/dashboard",
          }
        } else { 
          this.reportsAccessData = {
            text: "ON",
            class: "text-success",
            href: "#/analytics",
          }
        }
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar () {
        this.$sidebar.toggleMinimize()
      },
      logout () {
        this.$modal.show(ModalOptions,
            {
              title: "Logout?",
              message: "Are you sure you want to log out?",
              message2: "Any unsaved changes you have made will be lost!",
              closeText: "Cancel",
              actionText1: "Logout",
              closeAction: () => 
                {
                  this.$modal.close()
                },
              action1: () => 
                {
                  this.$modal.close()
                  this.$api.logout()
                    .then(reponse => {
                      this.$store.commit('logout')
                      this.$router.push('/login')
                    })
                }
              })
      }
    }
  }

</script>
<style>

</style>
